import React, { useEffect, useState } from "react";
import { ThemeProvider } from "@material-ui/styles";
import { getTheme } from "../theme";
import { BRAND_THEME_BY_NAME } from "../constants";

const BrandThemeContext = React.createContext();

const DEFAULT_BRAND =
  process.env.REACT_APP_DEFAULT_BRAND &&
  BRAND_THEME_BY_NAME[process.env.REACT_APP_DEFAULT_BRAND]
    ? BRAND_THEME_BY_NAME[process.env.REACT_APP_DEFAULT_BRAND]
    : "GGT";

const BrandThemeProvider = ({ children }) => {
  const [themeName, _setThemeName] = useState(DEFAULT_BRAND);
  const [theme, setTheme] = useState(getTheme(themeName));

  useEffect(() => {
    if (!themeName) return;

    setTheme(getTheme(themeName));
  }, [themeName]);

  const setThemeName = themeName => {
    if (BRAND_THEME_BY_NAME[themeName])
      _setThemeName(BRAND_THEME_BY_NAME[themeName]);
  };

  return (
    <BrandThemeContext.Provider value={{ setThemeName, themeName }}>
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </BrandThemeContext.Provider>
  );
};

export { BrandThemeProvider, BrandThemeContext };
